import type { ColorSchemeFragment } from '#graphql-operations'

const DEFAULT_SWATCH = 'wine-on-lilac'

export function useColorScheme(colorScheme?: MaybeRefOrGetter<ColorSchemeFragment | undefined | null>, defaultSwatch: string = DEFAULT_SWATCH) {
  return computed(() => {
    const cs = toValue(colorScheme)
    return [
      cs?.invert ? 'inverted' : '',
      cs?.colorSwatch?.class ?? defaultSwatch,
    ]
  })
}

interface SwatchColor {
  background: string
  text: string
}

export function useColorSchemeColors(colorScheme?: MaybeRefOrGetter<ColorSchemeFragment | undefined | null>) {
  return computed(() => {
    const cs = toValue(colorScheme)
    const raw = cs?.colorSwatch?.color?.[0]
    if (!raw)
      return undefined
    const { background, text } = JSON.parse(raw) as SwatchColor
    return cs?.invert
      ? { foreground: background, background: text }
      : { foreground: text, background }
  })
}
